import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Interweave } from "interweave";

import Header from "../../components/shared/header/Header";
import Breadcrumb from "../../components/shared/breadcrumb/Breadcrumb";
import Footer from "../../components/shared/footer/Footer";
import Spinner from "components/shared/Spinner/Spinner";

import AnalyticsService from "../../services/analytics";

const documentationMap = {
  "aszf": {
    id: "1060",
    key: "3cc481d8f4d6f08dc71e33a6ad3d434a"
  },
  "adatkezeles": {
    id: "1061",
    key: "b5db4eeeb38ce0012504d581379999d4"
  },
  "suti-tajekoztato": {
    id: "1062",
    key: "033ab3b45f88f4aa1e4a979173dd2748"
  },
  "jogi-nyilatkozat": {
    id: "1063",
    key: "4ef55bf48dc3ce8c5dedd730baa6ee8a"
  },
  "fogyasztovedelem": {
    id: "1064",
    key: "8bf0c9f7be96adef078567ea87e7571c"
  },
  "impresszum": {
    id: "1065",
    key: "82dc4272750fb6987e63f04e4d8bd7de"
  }
};

function Legal() {
  const [content, setContent] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);
  const { id } = useParams();

  const getDocumentationId = (id) => {
    return documentationMap[id] || null;
  };

  const decodeHtmlEntities = (value) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = value;

    return textarea.value;
  };

  const decodeEncodedHtml = (value) => {
    let result = value;

    for (let i = 0; i < 3; i += 1) {
      const decoded = decodeHtmlEntities(result);

      if (decoded === result) {
        break;
      }

      result = decoded;

      if (/<[a-z][\s\S]*>/i.test(result)) {
        break;
      }
    }

    return result;
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });

    AnalyticsService.sendPageView(window.location.pathname);

    const controller = new AbortController();

    const getItems = async () => {
      setIsLoaded(false);
      setError(false);

      try {
        const response = await fetch(
          `https://api.adatjogasz.hu/v1/getContract.php?apiKey=${getDocumentationId(id).key}&reqID=${getDocumentationId(id).id}&ct=xml`
        );

        if (!response.ok) {
          throw new Error(
            `Sikertelen API-kérés: ${response.status} ${response.statusText}`
          );
        }

        const xmlText = await response.text();

        const parser = new DOMParser();
        const xmlDocument = parser.parseFromString(
          xmlText,
          "application/xml"
        );

        const parserError = xmlDocument.querySelector("parsererror");

        if (parserError) {
          throw new Error("Az API válasza nem érvényes XML.");
        }

        const contentNode =
      xmlDocument.querySelector("content, contract, html, document") ??
      xmlDocument.documentElement;

        const rawContent = contentNode?.textContent?.trim() ?? "";
        const htmlContent = decodeEncodedHtml(rawContent);

        setContent(htmlContent);
      } catch (error) {
        console.error(error);
        setError(true);
      } finally {
        setIsLoaded(true);
      }
    };

    getItems();

    return () => {
      controller.abort();
    };
  }, [id]);

  if (error) {
    return <div>Hiba történt!</div>;
  }

  if (!isLoaded) {
    return <Spinner />;
  }

  return (
    <div className="static-content__container">
      <Header />
      <Breadcrumb />
      <section className="container">
        <div className="row">
          <div className="col-sm-12">
            <Interweave
              className="static-content__text"
              content={content}
              allowList={[
                "iframe",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "p",
                "strong",
                "br",
                "img",
                "table",
                "thead",
                "tbody",
                "tr",
                "th",
                "td",
                "a"
              ]}
              tagName="div"
            />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Legal;
